// @ts-nocheck
const request = require.context('@template/page/_component/modal/', false, /^(\.\/modal).*(\.vue)$/);
let modal: any = {};

request.keys().map((v: string) => {
  const name = v.replace('./', '')
    .replace('.vue', '');
  
  modal[name] = request(v).default;
});

export default modal;